import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { userContext } from "../../../stores/users/userContext";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";
import OnboardingModal from "../../onboarding/modal/OnboardingModal";
import ModalHeader from "../../onboarding/modal/ModalHeader";
import ModalContent from "../../onboarding/modal/ModalContent";
import OnboardingFlow from "../../onboarding/OnboardingFlow";
import NavigationBar from "./navigation/NavigationBar";
import HeroSection from "./hero/HeroSection";
import LearningCenterSection from "./learning-center/LearningCenterSection";
import Footer from "./footer/Footer";

const LandingPage: React.FC = () => {
  const userStore = useContext(userContext);
  const [modalOpen, setModalOpen] = useState(false);
  // Only mount modal content after first open so GoogleLogin mounts visible;
  // SDK does not inject the button when the container is hidden (keepMounted).
  const [hasModalBeenOpened, setHasModalBeenOpened] = useState(false);

  const handleAuthClick = () => {
    userStore.setPhase("get_email");
    setHasModalBeenOpened(true);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (userStore.isUserAuth()) {
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: "80px",
        backgroundColor: colors.background[850],
        color: colors.neutral.white,
      }}
    >
      <Box>
        <NavigationBar
          onSignUpClick={handleAuthClick}
          onLogInClick={handleAuthClick}
        />
        <HeroSection onCTAClick={handleAuthClick} />
      </Box>
      <LearningCenterSection onCTAClick={handleAuthClick} />
      {/* TODO: Re-enable when pricing plans will be enabled and fully implemented. */}
      {/* <PricingSection onCTAClick={handleAuthClick} /> */}
      <Footer />

      <OnboardingModal open={modalOpen} onClose={handleCloseModal}>
        {hasModalBeenOpened ? (
          <>
            <ModalHeader onClose={handleCloseModal} />
            <ModalContent>
              <OnboardingFlow />
            </ModalContent>
          </>
        ) : null}
      </OnboardingModal>
    </Box>
  );
};

export default observer(LandingPage);
